import { clamp } from '../../render/utils/math';

export const binarize = {
  name: 'binarize',
  shader: `precision mediump float;
varying vec2 v_texCoord;
uniform sampler2D u_image;
uniform float u_threshold;

void main() {
  vec4 color = texture2D(u_image, v_texCoord);
  
  float luma = dot(color.rgb, vec3(0.299, 0.587, 0.114));

  float final_color = step(u_threshold, luma);
  
  float final_color_match_js;
  if (luma <= u_threshold) {
      final_color_match_js = 0.0;
  } else {
      final_color_match_js = 1.0;
  }

  gl_FragColor = vec4(vec3(final_color_match_js), color.a);
}
`,
  uniforms: [
    {
      name: 'u_threshold',
      default: 0.5,
      normalize: (val: number) => clamp(val / 100, 0, 1),
    },
  ],
};
